export default "__VITE_ASSET__DqJZvh5X__"